<template>
  <div>
    <a-modal
      :visible="visible"
      title="新增产品"
      class="add-product-model"
      cancelText="取消"
      okText="保存"
      @cancel="$emit('onCancel')"
      @ok="handleOk"
    >
      <a-form
        :form="form"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
        @submit="handleOk"
      >
        <a-form-item label="产品名称" :colon="false" :required="true">
          <a-input
            style="width: 92%"
            placeholder="请输入需要新增的产品名称"
            v-decorator="[
              'product_name',
              {
                rules: [
                  { required: true, message: '请输入需要新增的产品名称' },
                ],
              },
            ]"
          />
        </a-form-item>
        <template>
          <a-form-item
            v-for="(item, index) in product_spec.options"
            :key="item.key"
            :colon="false"
            :label="`规格${index + 1}`"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 17 }"
          >
            <a-input
              v-decorator="[
                `${item.key}.value`,
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入规格',
                    },
                  ],
                },
              ]"
              placeholder="请输入规格"
              style="width: 92%; margin-right: 8px"
            />
            <a-icon
              v-if="product_spec.options.length > 1"
              class="question-delete-button"
              type="minus-circle-o"
              :disabled="product_spec.options.length === 1"
              @click="() => remove(index)"
            />
          </a-form-item>
        </template>
        <a-form-item :colon="false" :wrapper-col="{ span: 17, offset: 5 }">
          <a-button type="dashed" @click="add">
            <a-icon type="plus" /> 增加规格
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
  <script>
const uuidv1 = require("uuid/v1");
export default {
  props: ["visible"],
  data() {
    return {
      form: {
        product_name: "",
        spec: [],
      },
      product_name: "",
      product_spec: { options: [{ key: uuidv1(), value: "" }] },
    };
  },
  watch: {
    visible: function () {
      this.product_name = "";
      this.form = this.$form.createForm(this);
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let product_spec = [];
          let product_name = "";
          Object.values(values).forEach((item, index) => {
            if (typeof item === "object") {
              product_spec.push(item.value);
            } else {
              product_name = item;
            }
          });

          this.$emit("onSubmit", product_name, product_spec);
        }
      });
    },
    add() {
      this.product_spec.options.push({ key: uuidv1(), value: "" });
      this.product_spec = JSON.parse(JSON.stringify(this.product_spec));
    },
    remove(key) {
      this.product_spec.options = this.product_spec.options.filter(
        (item, index) => index !== key
      );
    },
  },
};
</script>
  <style>
.add-product-model .ant-modal-title {
  margin: 0 !important;
}
.add-product-model .ant-modal-header {
  border-bottom: 1px solid #e8e8e8 !important;
  border-radius: 4px 4px 0 0 !important;
  height: auto !important;
}
.ant-form-item-no-colon .ant-form-item-label {
  margin-right: 0;
}
</style>